import React from 'react';

interface AvatarGroupProps {
  items: Array<{
    name: string;
    photo_url?: string | null;
  }>;
  max?: number;
  size?: number;
}

const COLORS = ['#4f46e5', '#7c3aed', '#059669', '#d97706', '#dc2626', '#0891b2', '#be185d'];

const AvatarGroup: React.FC<AvatarGroupProps> = ({ items, max = 4, size = 30 }) => {
  const visible = items.slice(0, max);
  const remaining = items.length - max;

  return (
    <div className="crm-avatar-group">
      {visible.map((item, i) => (
        <div
          key={i}
          className="crm-avatar-group__item"
          style={{
            width: size,
            height: size,
            backgroundColor: COLORS[i % COLORS.length],
            fontSize: Math.round(size * 0.37),
          }}
          title={item.name}
        >
          {item.photo_url ? (
            <img src={item.photo_url} alt={item.name} />
          ) : (
            (item.name[0] ?? '').toUpperCase()
          )}
        </div>
      ))}
      {remaining > 0 && (
        <div
          className="crm-avatar-group__more"
          style={{ width: size, height: size, fontSize: Math.round(size * 0.33) }}
        >
          +{remaining}
        </div>
      )}
    </div>
  );
};

export default AvatarGroup;
